webpackJsonp([33],{

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clause03_vue__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3a1ee2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_clause03_vue__ = __webpack_require__(736);
var normalizeComponent = __webpack_require__(63)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clause03_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3a1ee2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_clause03_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "clause03",
  data: function data() {
    return {
      // privacy_policy_url: 'https://www.orangeconnex.com/customer/privacy-policy.html'
      privacy_policy_url: '/customer/privacy-policy.html'
    };
  }
});

/***/ }),

/***/ 736:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header other-banner other-banner-clause",attrs:{"id":""}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"other-banner-title"},[_vm._v(_vm._s(_vm.$t('clause.Policies')))])])]),_vm._v(" "),_c('div',{staticClass:"content bgf5f5f5"},[_c('div',[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"container sub-nav clause-nav"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:" ",attrs:{"to":"clauseConditions"}},[_vm._v(_vm._s(_vm.$t('clause.TermsConditions')))]),_vm._v(" "),_c('router-link',{staticClass:" ",attrs:{"to":"clauseService"}},[_vm._v(_vm._s(_vm.$t('clause.ServiceDisclaimer')))]),_vm._v(" "),_c('router-link',{staticClass:" cur",attrs:{"to":"clausePrivacy"}},[_vm._v(_vm._s(_vm.$t('clause.PrivacyDisclaimer')))])],1)]),_vm._v(" "),_c('div',{staticClass:"container col-jj"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"clause_con"},[_c('div',{staticClass:"clause_w_con",staticStyle:{"line-height":"1.6"}},[_c('html-panel',{attrs:{"url":_vm.privacy_policy_url}})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// resource/js/33.1fd14fad87a28c5bd1db.js